import type { Components, Theme } from '@mui/material/styles';
import { fontFamily } from '@/@mui/tokens/font-family';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { typography } from '@/@mui/tokens/typography';

export const MuiAlertTitle: Components<Theme>['MuiAlertTitle'] = {
  styleOverrides: {
    root: {
      fontFamily: fontFamily.fontFamilyCarbona,
      fontWeight: fontWeights.fontWeightSemibold,
      marginBottom: 0,
      fontSize: typography.body2.fontSize,
    },
  },
};
